<template>
  <section id="sliderType" class="slider__wrap" :class="fonts">
    <div className="slider__innner">
      <h2 class="blind">슬라이드 영역</h2>
      <swiper
        :navigation="true"
        :modules="modules"
        :autoplay="{
          delay: 2500,
          disableOnInteraction: false,
        }"
        :pagination="{
          clickable: true,
        }"
        class="mySwiper"
      >
        <swiper-slide
          ><div class="desc">
            <span>Journey</span>
            <h3>The Blue Sea</h3>
            <p>
              보고 있으면 마음이 편안해지는 수평선과<br />
              푸른 물결을 감상해 볼까요?
            </p>
            <div class="btn">
              <a href="#">자세히 보기</a>
              <a href="#" class="black">사이트 보기</a>
            </div>
          </div></swiper-slide
        >
        <swiper-slide
          ><div class="desc">
            <span>Journey</span>
            <h3>The Blue Sea</h3>
            <p>
              보고 있으면 마음이 편안해지는 수평선과<br />
              푸른 물결을 감상해 볼까요?
            </p>
            <div class="btn">
              <a href="#">자세히 보기</a>
              <a href="#" class="black">사이트 보기</a>
            </div>
          </div></swiper-slide
        >
        <swiper-slide
          ><div class="desc">
            <span>Journey</span>
            <h3>The Blue Sea</h3>
            <p>
              보고 있으면 마음이 편안해지는 수평선과<br />
              푸른 물결을 감상해 볼까요?
            </p>
            <div class="btn">
              <a href="#">자세히 보기</a>
              <a href="#" class="black">사이트 보기</a>
            </div>
          </div></swiper-slide
        >
      </swiper>
    </div>
  </section>
</template>
<script>
import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Pagination, Autoplay } from "swiper";
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    return {
      modules: [Navigation, Pagination, Autoplay],
    };
  },
  props: {
    fonts: String,
  },
};
</script>

<style>
.slider__innner {
  margin-top: 70px;
}
.slider {
  position: relative;
}
.slider__img {
  background: url(../../assets/img/slider_bg01.jpg) no-repeat center / cover;
}
.slider__img .desc {
  width: 1160px;
  margin: 0 auto;
  padding: 100px 20px;
}
.slider__img .desc span {
  font-size: 16px;
  background-color: #fff;
  padding: 1px 14px 0;
  border-radius: 30px;
  text-transform: uppercase;
  margin-bottom: 10px;
  display: inline-block;
}
.slider__img .desc h3 {
  font-size: 110px;
  font-weight: 300;
  line-height: 1;
  color: #fff;
  text-transform: uppercase;
  margin-bottom: 16px;
  margin-left: -8px;
}
.slider__img .desc p {
  font-size: 20px;
  font-weight: 300;
  color: #fff;
  line-height: 1.35;
  margin-bottom: 130px;
}
.slider__img .desc .btn a {
  font-size: 16px;
  background-color: #fff;
  padding: 11px 50px;
  display: inline-block;
}
.slider__img .desc a.black {
  background: #000;
  color: #fff;
}
.slider__arrow a {
  position: absolute;
  top: 50%;
  width: 30px;
  height: 56px;
  background-image: url(../../assets/img/slider_icon.svg);
  transform: translateY(-50%);
}
.slider__arrow .left {
  left: 20px;
}
.slider__arrow .right {
  right: 20px;
  background-position-x: -50px;
}
.slider__dot {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 25px;
}
.slider__dot a {
  display: inline-block;
  width: 16px;
  height: 16px;
  background-image: url(../../assets/img/slider_icon.svg);
  background-position: -20px -70px;
}
.slider__dot a.active {
  background-position: 0 -70px;
}
.slider__dot a.play {
  background-position: -40px -70px;
}
.slider__dot a.stop {
  background-position: -60px -70px;
}

.swiper-slide {
  background: url(../../assets/img/slider_bg01.jpg) no-repeat center / cover;
}
.swiper-slide:nth-child(2) {
  background: url(../../assets/img/slider_bg02.jpg) no-repeat center / cover;
}
.swiper-slide:nth-child(3) {
  background: url(../../assets/img/slider_bg03.jpg) no-repeat center / cover;
}
.swiper-slide .desc {
  width: 1160px;
  margin: 0 auto;
  padding: 100px 20px;
  box-sizing: border-box;
}
.swiper-slide .desc span {
  font-size: 16px;
  background-color: #fff;
  padding: 1px 14px 0;
  border-radius: 30px;
  text-transform: uppercase;
  margin-bottom: 10px;
  display: inline-block;
}
.swiper-slide .desc h3 {
  font-size: 110px;
  font-weight: 300;
  line-height: 1;
  color: #fff;
  text-transform: uppercase;
  margin-bottom: 16px;
  margin-left: -8px;
}
.swiper-slide .desc p {
  font-size: 20px;
  font-weight: 300;
  color: #fff;
  line-height: 1.35;
  margin-bottom: 130px;
}
.swiper-slide .desc .btn a {
  font-size: 16px;
  background-color: #fff;
  padding: 11px 50px;
  display: inline-block;
}
.swiper-slide .desc a.black {
  background: #000;
  color: #fff;
}
.swiper-button-next,
.swiper-button-prev {
  width: 30px !important;
  height: 56px !important;
  background: url(../../assets/img/slider_icon.svg);
}
.swiper-button-next {
  background-position-x: -50px;
}
.swiper-button-prev:after,
.swiper-button-next:after {
  opacity: 0;
}
.swiper-pagination-bullet {
  width: 16px !important;
  height: 16px !important;
  background-image: url(../../assets/img/slider_icon.svg) !important;
  background-position: -20px -70px !important;
  background-color: transparent !important;
  opacity: 1 !important;
}
.swiper-pagination-bullet-active {
  background-position: 0 -70px !important;
}
.swiper-button {
  display: flex;
  position: absolute;
  left: 50%;
  margin-left: 40px;
  bottom: 24px;
  z-index: 1000;
}
.swiper-button-stop {
  background-image: url(../../assets/img/slider_icon.svg);
  background-position: -60px -70px;
  width: 16px;
  height: 16px;
  cursor: pointer;
}
.swiper-button-play {
  background-image: url(../../assets/img/slider_icon.svg);
  background-position: -40px -70px;
  width: 16px;
  height: 16px;
  cursor: pointer;
}

/* media */
@media (max-width: 960px) {
  .swiper-slide .desc {
    width: 100%;
    text-align: center;
  }
  .swiper-slide .desc h3 {
    font-size: 70px;
  }
}
@media (max-width: 600px) {
  .swiper-slide .desc {
    padding: 80px 0;
  }
  .swiper-slide .desc h3 {
    font-size: 40px;
  }
  .swiper-slide .desc p {
    font-size: 16px;
    margin-bottom: 50px;
  }
  .swiper-slide .desc .btn a {
    padding: 10px 25px;
  }
}
</style>
